"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgWaterTapLowOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.water-tap-low_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "water-tap-low_outline_svg__transparent_box" },
            React.createElement("path", { className: "water-tap-low_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "water-tap-low_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "water-tap-low_outline_svg__OUTLINE" },
            React.createElement("circle", { cx: 13, cy: 21, r: 1 }),
            React.createElement("circle", { cx: 13, cy: 25, r: 1 }),
            React.createElement("path", { d: "M17 14h9v-2h-9a2 2 0 00-2 2v2h-4v-4.3A3.7 3.7 0 0114.69 8H26V6h-5V3h3V1h-8v2h3v3h-4.3A5.71 5.71 0 009 11.7V18h8zM6 28h20v2H6z" }))));
}
exports.default = SvgWaterTapLowOutline;
//# sourceMappingURL=WaterTapLowOutline.js.map